var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmergencyStopType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_730",
    "data-name": "Group 730",
    transform: "translate(-1223 -196.545)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M3068.981,0l-.28,6.122h-1.476L3066.932,0Zm.073,7.871a.9.9,0,0,0-.243-.673,1.512,1.512,0,0,0-1.622,0,.869.869,0,0,0-.256.673.838.838,0,0,0,.256.69,1.273,1.273,0,0,0,.8.207,1.138,1.138,0,0,0,.818-.241A.882.882,0,0,0,3069.054,7.871Z",
    transform: "translate(-1831.993 207.407)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    transform: "translate(1223 196.545)",
    fill: "none",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.388,4.621a3,3,0,0,1,5.223,0l7.858,13.9A3,3,0,0,1,20.858,23H5.142A3,3,0,0,1,2.53,18.524Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12.99999809265137 4.596843719482422 C 12.73684787750244 4.596843719482422 12.08283805847168 4.671085357666016 11.6941385269165 5.358774185180664 L 3.835857391357422 19.26190567016602 C 3.453268051147461 19.93879508972168 3.715578079223633 20.5322151184082 3.846107482910156 20.75594520568848 C 3.976638793945312 20.97965431213379 4.364187240600586 21.50000381469727 5.141698837280273 21.50000381469727 L 20.85829925537109 21.50000381469727 C 21.63580703735352 21.50000381469727 22.02335739135742 20.97965431213379 22.15388870239258 20.75594520568848 C 22.2844181060791 20.5322151184082 22.54672813415527 19.93879508972168 22.16414833068848 19.26191520690918 L 14.30583763122559 5.3587646484375 C 13.91714763641357 4.671085357666016 13.26313781738281 4.596843719482422 12.99999809265137 4.596843719482422 M 12.99999523162842 3.096847534179688 C 14.01874160766602 3.096847534179688 15.03748321533203 3.604789733886719 15.61167812347412 4.620674133300781 L 23.4699878692627 18.52382469177246 C 24.6003475189209 20.52370452880859 23.155517578125 23.00000381469727 20.85829925537109 23.00000381469727 L 5.141698837280273 23.00000381469727 C 2.844478607177734 23.00000381469727 1.399648666381836 20.52370452880859 2.530008316040039 18.52382469177246 L 10.38829803466797 4.620683670043945 C 10.96249771118164 3.604795455932617 11.98124980926514 3.096847534179688 12.99999523162842 3.096847534179688 Z",
    stroke: "none",
    fill: "#000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergencyStopType);
export default __webpack_public_path__ + "static/media/emergencyStopType.8372318d.svg";
export { ForwardRef as ReactComponent };